import { createFileRoute } from '@tanstack/react-router';

import { ConnectOfferLandingPage } from 'src/apps/checkout/app/pages/ConnectOffer.Landing';

export const Route = createFileRoute(
  '/_auth/_only-header/store/connect-offer/_allowed/'
)({
  component: () => <ConnectOfferLandingPage />,
});
